/**
 * "Is a WhatsApp call ringing or live in this tab?" for code outside the
 * softphone - e.g. "Update now" must not reload the page mid-call. Written by
 * useWhatsAppCall, read anywhere. Plain module state: one softphone per tab.
 */
let active = false;

export const setCallActive = (value: boolean): void => {
  active = value;
};

export const isCallActive = (): boolean => active;
